<template>
    <div class="split-button">
        <div v-for="(item, index) in items" :key="index" :class="['button', activeItem == item ? 'active' : '']" @click="setActive(item)">
            {{ item }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'split-button',
    props: ['items'],
    data() {
        return {
            activeItem: this.items[0],
        }
    },
    methods: {
        setActive(item) {
            this.activeItem = item
            this.$emit('click', item)
        }
    },
}
</script>
<style lang="scss">
.split-button {
    display: flex;
    flex-flow: row nowrap;

    .button {
        flex: 1 1 auto;
        border-top: solid 1px #949494;
        border-bottom: solid 1px #949494;
        border-left: solid 1px #949494;
        border-right: none;
        background: white;
        padding: 5px 0;

        &.active {
            background: #0098eb;
            border-color:#0098eb; 
            color: white;
        }

        &:first-child {
            border-radius: 6px 0 0 6px;
        }
        &:last-child {
            border-radius: 0 6px 6px 0;
            border-right: solid 1px #949494;
        }
    }
}
</style>
